(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const nativeSelector = 'select[data-vf-localization-select]';
    const customSelector = '.vf-footer__custom-select';

    function getVfLocalizationParts(customSelect) {
      return {
        trigger: customSelect.querySelector('.vf-footer__custom-trigger'),
        menu: customSelect.querySelector('.vf-footer__custom-menu'),
        options: Array.from(customSelect.querySelectorAll('.vf-footer__custom-option')),
      };
    }

    function closeVfLocalizationMenu(customSelect, returnFocus = false) {
      if (!customSelect) return;

      const { trigger, menu } = getVfLocalizationParts(customSelect);
      customSelect.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;

      if (returnFocus) trigger.focus();
    }

    function closeOtherVfLocalizationMenus(currentSelect) {
      document.querySelectorAll(customSelector).forEach((customSelect) => {
        if (customSelect !== currentSelect) closeVfLocalizationMenu(customSelect);
      });
    }

    function openVfLocalizationMenu(customSelect, focusIndex) {
      const { trigger, menu, options } = getVfLocalizationParts(customSelect);
      closeOtherVfLocalizationMenus(customSelect);
      customSelect.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;

      if (Number.isInteger(focusIndex) && options.length) {
        const safeIndex = Math.max(0, Math.min(focusIndex, options.length - 1));
        options[safeIndex].focus();
      }
    }

    function selectVfLocalizationOption(customSelect, optionButton) {
      const nativeSelect = document.getElementById(customSelect.dataset.selectId);
      const { trigger, options } = getVfLocalizationParts(customSelect);
      const valueLabel = trigger.querySelector('.vf-footer__custom-value');

      if (!nativeSelect || !optionButton) return;

      nativeSelect.value = optionButton.dataset.value;
      valueLabel.textContent = optionButton.textContent;
      trigger.setAttribute('aria-label', `${customSelect.dataset.label}: ${optionButton.textContent}`);
      options.forEach((option) => {
        option.setAttribute('aria-selected', option === optionButton ? 'true' : 'false');
      });
      closeVfLocalizationMenu(customSelect);
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function handleVfLocalizationMenuKeydown(event, customSelect) {
      const { options } = getVfLocalizationParts(customSelect);
      const activeIndex = options.indexOf(document.activeElement);

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          options[(activeIndex + 1) % options.length].focus();
          break;
        case 'ArrowUp':
          event.preventDefault();
          options[(activeIndex - 1 + options.length) % options.length].focus();
          break;
        case 'Home':
          event.preventDefault();
          options[0].focus();
          break;
        case 'End':
          event.preventDefault();
          options[options.length - 1].focus();
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          selectVfLocalizationOption(customSelect, options[activeIndex]);
          break;
        case 'Escape':
          event.preventDefault();
          closeVfLocalizationMenu(customSelect, true);
          break;
        case 'Tab':
          closeVfLocalizationMenu(customSelect);
          break;
      }
    }

    function buildVfLocalizationMenu(nativeSelect) {
      const wrap = nativeSelect.closest('.vf-footer__select-wrap');
      const nativeOptions = Array.from(nativeSelect.options);

      if (!wrap || !nativeSelect.id || !nativeOptions.length) return;

      const label = document.querySelector(`label[for="${nativeSelect.id}"]`);
      const selectedIndex = Math.max(nativeSelect.selectedIndex, 0);
      const selectedOption = nativeOptions[selectedIndex];
      const customSelect = document.createElement('div');
      const trigger = document.createElement('button');
      const valueLabel = document.createElement('span');
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const firstStroke = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      const secondStroke = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      const menu = document.createElement('div');
      const menuId = `${nativeSelect.id}-CustomMenu`;
      const accessibleLabel = label?.textContent.trim() || nativeSelect.name;

      customSelect.className = 'vf-footer__custom-select';
      customSelect.dataset.selectId = nativeSelect.id;
      customSelect.dataset.label = accessibleLabel;

      trigger.type = 'button';
      trigger.className = 'vf-footer__custom-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', menuId);
      trigger.setAttribute('aria-label', `${accessibleLabel}: ${selectedOption.textContent}`);

      valueLabel.className = 'vf-footer__custom-value';
      valueLabel.textContent = selectedOption.textContent;

      icon.classList.add('vf-footer__custom-trigger-icon');
      icon.setAttribute('viewBox', '0 0 14 14');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', 'currentColor');
      icon.setAttribute('stroke-width', '1.5');
      icon.setAttribute('aria-hidden', 'true');
      firstStroke.setAttribute('d', 'M2.5 5 7 9.5');
      secondStroke.setAttribute('d', 'M7 9.5 11.5 5');
      icon.append(firstStroke, secondStroke);
      trigger.append(valueLabel, icon);

      menu.id = menuId;
      menu.className = 'vf-footer__custom-menu';
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', accessibleLabel);
      menu.hidden = true;

      nativeOptions.forEach((nativeOption, index) => {
        const optionButton = document.createElement('button');
        optionButton.type = 'button';
        optionButton.id = `${menuId}-Option-${index}`;
        optionButton.className = 'vf-footer__custom-option';
        optionButton.dataset.value = nativeOption.value;
        optionButton.textContent = nativeOption.textContent;
        optionButton.setAttribute('role', 'option');
        optionButton.setAttribute('aria-selected', index === selectedIndex ? 'true' : 'false');
        optionButton.addEventListener('click', () => {
          selectVfLocalizationOption(customSelect, optionButton);
        });
        menu.append(optionButton);
      });

      trigger.addEventListener('click', () => {
        if (customSelect.classList.contains('is-open')) {
          closeVfLocalizationMenu(customSelect);
        } else {
          openVfLocalizationMenu(customSelect);
        }
      });

      trigger.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            openVfLocalizationMenu(customSelect, selectedIndex);
            break;
          case 'ArrowUp':
            event.preventDefault();
            openVfLocalizationMenu(customSelect, selectedIndex);
            break;
          case 'Escape':
            event.preventDefault();
            closeVfLocalizationMenu(customSelect);
            break;
        }
      });

      menu.addEventListener('keydown', (event) => {
        handleVfLocalizationMenuKeydown(event, customSelect);
      });

      customSelect.append(trigger, menu);
      wrap.append(customSelect);
      nativeSelect.setAttribute('aria-hidden', 'true');
      nativeSelect.tabIndex = -1;
      wrap.classList.add('is-enhanced');
      nativeSelect.dataset.vfLocalizationInitialized = 'true';
    }

    function initVfLocalizationMenus(root = document) {
      const candidates = root.matches?.(nativeSelector)
        ? [root]
        : Array.from(root.querySelectorAll(nativeSelector));

      candidates.forEach((nativeSelect) => {
        if (nativeSelect.dataset.vfLocalizationInitialized === 'true') return;

        try {
          buildVfLocalizationMenu(nativeSelect);
        } catch (error) {
          nativeSelect.closest('.vf-footer__select-wrap')?.classList.remove('is-enhanced');
          nativeSelect.parentElement?.querySelector(customSelector)?.remove();
          delete nativeSelect.dataset.vfLocalizationInitialized;
        }
      });
    }

    if (!window.__vfLocalizationMenusBound) {
      document.addEventListener('pointerdown', (event) => {
        if (!event.target.closest(customSelector)) {
          document.querySelectorAll(customSelector).forEach((customSelect) => {
            closeVfLocalizationMenu(customSelect);
          });
        }
      });

      document.addEventListener('shopify:section:load', (event) => {
        initVfLocalizationMenus(event.target);
      });

      window.__vfLocalizationMenusBound = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initVfLocalizationMenus());
    } else {
      initVfLocalizationMenus();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reliable-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class SearchDiscoveryRecommendations extends HTMLElement {
    mobile_breakpoint = window.matchMedia('(max-width: 749px)');

    connectedCallback() {
      this.mobile_breakpoint.addEventListener('change', this.update_slideshow_playback);
      customElements.whenDefined('slideshow-component').then(() => {
        this.bind_navigation();
        this.update_slideshow_playback();
      });

      if (this.dataset.loaded === 'true' || !this.dataset.productId) return;
      this.loadRecommendations();
    }

    disconnectedCallback() {
      this.mobile_breakpoint.removeEventListener('change', this.update_slideshow_playback);
      this.scroller?.removeEventListener('scroll', this.update_navigation);

      if (this.slideshow && this.native_navigation) {
        this.slideshow.previous = this.native_navigation.previous;
        this.slideshow.next = this.native_navigation.next;
      }
    }

    get slideshow() {
      return this.querySelector('.reliable-product-recommendations__carousel > slideshow-component');
    }

    get navigation_controls() {
      return {
        previous: this.slideshow?.querySelector(':scope > slideshow-container > slideshow-arrows .slideshow-control--previous'),
        next: this.slideshow?.querySelector(':scope > slideshow-container > slideshow-arrows .slideshow-control--next'),
      };
    }

    get scroller() {
      return this.slideshow?.querySelector(':scope > slideshow-container > slideshow-slides');
    }

    bind_navigation = () => {
      const slideshow = this.slideshow;
      if (!slideshow || this.native_navigation) return;

      this.native_navigation = {
        previous: slideshow.previous.bind(slideshow),
        next: slideshow.next.bind(slideshow),
      };
      this.scroller?.addEventListener('scroll', this.update_navigation, { passive: true });
      this.update_navigation();
    };

    show_previous_slide = () => this.scroll_by(-1);

    show_next_slide = () => this.scroll_by(1);

    scroll_by = (direction) => {
      const scroller = this.scroller;
      if (!scroller) return;

      scroller.scrollBy({
        left: direction * scroller.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    update_navigation = () => {
      if (!this.mobile_breakpoint.matches) return;

      const scroller = this.scroller;
      const { previous, next } = this.navigation_controls;
      if (!scroller || !previous || !next) return;

      const max_scroll = scroller.scrollWidth - scroller.clientWidth;
      previous.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max_scroll - 2;
    };

    update_slideshow_playback = () => {
      const slideshow = this.slideshow;
      if (!slideshow) return;

      if (this.mobile_breakpoint.matches) {
        slideshow.removeAttribute('infinite');
        slideshow.previous = this.show_previous_slide;
        slideshow.next = this.show_next_slide;
        slideshow.pause();
        this.update_navigation();
      } else {
        if (this.native_navigation) {
          slideshow.previous = this.native_navigation.previous;
          slideshow.next = this.native_navigation.next;
        }
        slideshow.setAttribute('infinite', '');
        slideshow.play();
      }
    };

    async loadRecommendations() {
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('product_id', this.dataset.productId);
      url.searchParams.set('limit', this.dataset.limit);
      url.searchParams.set('intent', 'related');

      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = documentFragment.querySelector('search-discovery-recommendations');

        if (nextSection) this.replaceWith(nextSection);
      } catch {}
    }
  }

  if (!customElements.get('search-discovery-recommendations')) {
    customElements.define('search-discovery-recommendations', SearchDiscoveryRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-home-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initializeFaq(root) {
      root.querySelectorAll('.portable-faq__item').forEach((item) => {
        if (initialized.has(item)) return;
        initialized.add(item);
        const summary = item.querySelector('summary');
        let animation;
        let expanding = item.open;

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          expanding = animation ? !expanding : !item.open;
          const startHeight = item.getBoundingClientRect().height;
          animation?.cancel();
          item.removeAttribute('data-closing');

          if (reducedMotion.matches || !item.animate) {
            animation = null;
            item.style.overflow = '';
            item.open = expanding;
            return;
          }

          item.open = true;
          const border = parseFloat(getComputedStyle(item).borderBottomWidth) || 0;
          const endHeight = expanding
            ? item.getBoundingClientRect().height
            : summary.getBoundingClientRect().height + border;
          item.toggleAttribute('data-closing', !expanding);
          item.style.overflow = 'hidden';
          animation = item.animate(
            { height: [`${startHeight}px`, `${endHeight}px`] },
            { duration: 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          animation.onfinish = () => {
            item.open = expanding;
            item.style.overflow = '';
            item.removeAttribute('data-closing');
            animation = null;
          };
        });
      });
    }

    initializeFaq(document);
    document.addEventListener('shopify:section:load', (event) => initializeFaq(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-loop-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vf-loop-video')) {
    customElements.define('vf-loop-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.video.muted = true;
        const sync = () => {
          if (this.visible && !document.hidden && !this.reducedMotion.matches) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        document.addEventListener('visibilitychange', sync, options);
        this.reducedMotion.addEventListener('change', sync, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.1 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-support-center"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vf-support-topic')) {
  customElements.define('vf-support-topic', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-enhanced')) return;
      const select = this.querySelector('select');
      if (!select) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const label = document.querySelector('label[for="' + select.id + '"]');
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'vf-topic-trigger';
      trigger.id = select.id + '-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const menu = document.createElement('div');
      menu.className = 'vf-topic-menu';
      menu.id = select.id + '-menu';
      menu.role = 'listbox';
      menu.setAttribute('aria-label', label ? label.textContent : 'Support topic');
      menu.hidden = true;
      trigger.setAttribute('aria-controls', menu.id);
      this.append(trigger, menu);
      const buttons = [...select.options].filter(o => o.value).map(o => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'vf-topic-option';
        b.role = 'option';
        b.textContent = o.textContent;
        b.dataset.value = o.value;
        b.tabIndex = -1;
        menu.append(b);
        b.addEventListener('click', () => {
          select.value = o.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          close();
          trigger.focus();
        }, { signal });
        return b;
      });
      const sync = () => {
        trigger.textContent = select.selectedOptions[0]?.textContent || 'Choose a topic';
        buttons.forEach(b => b.setAttribute('aria-selected', String(b.dataset.value === select.value)));
        trigger.removeAttribute('aria-invalid');
      };
      const close = () => { menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
      const open = () => {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        (buttons.find(b => b.dataset.value === select.value) || buttons[0])?.focus();
      };
      trigger.addEventListener('click', () => menu.hidden ? open() : close(), { signal });
      trigger.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
      }, { signal });
      menu.addEventListener('keydown', e => {
        const i = buttons.indexOf(document.activeElement);
        let next;
        if (e.key === 'ArrowDown') next = (i + 1) % buttons.length;
        if (e.key === 'ArrowUp') next = (i - 1 + buttons.length) % buttons.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { e.preventDefault(); buttons[next]?.focus(); }
        if (e.key === 'Escape') { e.preventDefault(); close(); trigger.focus(); }
      }, { signal });
      document.addEventListener('click', e => { if (!this.contains(e.target)) close(); }, { signal });
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) close(); }, 0), { signal });
      select.addEventListener('change', sync, { signal });
      select.addEventListener('invalid', e => { e.preventDefault(); trigger.setAttribute('aria-invalid', 'true'); open(); }, { signal });
      select.form?.addEventListener('reset', () => setTimeout(() => { sync(); close(); }, 0), { signal });
      if (label) label.htmlFor = trigger.id;
      select.classList.add('vf-topic-native');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      this.setAttribute('data-enhanced', '');
      sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.querySelector('.vf-topic-trigger')?.remove();
      this.querySelector('.vf-topic-menu')?.remove();
      const select = this.querySelector('select');
      if (select) {
        const label = document.querySelector('label[for="' + select.id + '-trigger"]');
        if (label) label.htmlFor = select.id;
        select.classList.remove('vf-topic-native');
        select.removeAttribute('tabindex');
        select.removeAttribute('aria-hidden');
      }
      this.removeAttribute('data-enhanced');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
